<template>
    <BreadCrumb PageTitle="Liste des filières" />
    <ListeFiliere />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeFiliere from "../../components/Filiere/ListeFiliere.vue";

  
    export default defineComponent({
      name: "ListeFilierePage",
      components: {
        BreadCrumb,
        ListeFiliere,
      },
    });
  </script>